const badgesImages = import.meta.glob(
  "@images/accomplishments/badges/*.png",
  {
    eager: true
  }
)

export const constBadgeTitles = {
  "completed-onboarding": "Completed Onboarding",
  "completed-plan-onboarding": "Plan Onboarding",
  "uploaded-avatar": "Uploaded Photo",
  "community-builder": "Community Builder",
  "community-commenter": "Community Commenter",
  "community-reactor": "Community Reactor",
  "goal-completer": "Goal Completer",
  "goal-progress-reporter": "Goal Progress",
  recognizer: "Recognition",
  "recognition-commenter": "Recognition Commenter",
  "recognition-reactor": "Recognition Reactor",
  recognized: "Recognized",
  "task-completer": "Task Completer",
  "task-progress-reporter": "Task Progress"
}

/**
 * Returns the image URL for a badge based on its name and level.
 * @param {String} badgeName 
 * @param {Number} level
 * @returns {String}
 */
export function badgeImage(badgeName: string, level: number) {
  if (level) {
    return badgesImages[
      `/images/accomplishments/badges/${badgeName}-${level}.png`
    ]?.default
  } else {
    return badgesImages[`/images/accomplishments/badges/${badgeName}.png`]
      ?.default
  }
}